var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "body",
      {
        staticClass:
          "home page-template-default page page-id-314 wp-embed-responsive st-Grid_Container",
        staticStyle: { "overflow-y": "unset" },
        attrs: { "data-anchor": "pagetop" }
      },
      [
        _c("navbar", {
          attrs: {
            follow: "st-Header",
            imgSrc: "../../../../static/img/logo/logo-black.png"
          }
        }),
        _vm._v(" "),
        _c("div", { staticClass: "st-FixedPoint" }),
        _vm._v(" "),
        _c("div", { staticClass: "st-MainContainer" }, [
          _c(
            "main",
            {
              staticClass: "st-MainContents",
              staticStyle: { "padding-top": "120px" }
            },
            [
              _vm._m(0),
              _vm._v(" "),
              _c("section", { staticClass: "service-index-project-common" }, [
                _c(
                  "div",
                  { staticClass: "company-Profile_Inner pb-md-6 pb-6" },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "st-Grid_Inner p-0 service-index-appear-1",
                        attrs: { "data-appear": "true" }
                      },
                      [
                        _c(
                          "h2",
                          {
                            staticClass:
                              "common-text-appear text-center service-index-appear-2",
                            attrs: { "data-appear": "true" }
                          },
                          [
                            _c(
                              "span",
                              { staticClass: "sw-Section_Header-en pb-3" },
                              [
                                _c(
                                  "b",
                                  [
                                    _c(
                                      "font",
                                      [
                                        _c("font", [_vm._v("システム受託開発")])
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              ]
                            )
                          ]
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _vm._m(1)
                  ]
                )
              ]),
              _vm._v(" "),
              _c("section", { staticClass: "service-index-project-common" }, [
                _c(
                  "div",
                  { staticClass: "company-Profile_Inner pb-md-6 pb-6" },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "st-Grid_Inner p-0 service-index-appear-6",
                        attrs: { "data-appear": "true" }
                      },
                      [
                        _c(
                          "h2",
                          {
                            staticClass:
                              "common-text-appear text-center service-index-appear-7",
                            attrs: { "data-appear": "true" }
                          },
                          [
                            _c(
                              "span",
                              { staticClass: "sw-Section_Header-en pb-3" },
                              [
                                _c(
                                  "b",
                                  [
                                    _c(
                                      "font",
                                      [
                                        _c("font", [
                                          _vm._v(
                                            "ロボティクス自動化エンジニアリングサービス"
                                          )
                                        ])
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              ]
                            )
                          ]
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _vm._m(2)
                  ]
                )
              ])
            ]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "st-Breadcrumbs" }, [
            _c(
              "ul",
              {
                staticClass: "st-BreadcrumbsList",
                attrs: { itemscope: "itemscope", itemtype: "" }
              },
              [
                _c(
                  "li",
                  {
                    staticClass: "st-BreadcrumbsList_Item",
                    attrs: {
                      itemprop: "itemListElement",
                      itemscope: "itemscope",
                      itemtype: ""
                    }
                  },
                  [
                    _c(
                      "router-link",
                      {
                        staticClass: "st-BreadcrumbsList_Item-link",
                        attrs: { to: "/", itemprop: "item" }
                      },
                      [_vm._v("ホーム")]
                    ),
                    _vm._v(" "),
                    _c("meta", {
                      attrs: { itemprop: "position", content: "1" }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _vm._m(3)
              ]
            )
          ])
        ]),
        _vm._v(" "),
        _c("copyright")
      ],
      1
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("header", { staticClass: "series-PageTitle" }, [
      _c(
        "div",
        { staticClass: "series-PageTitle_Inner", attrs: { "data-appear": "" } },
        [
          _c("h1", [
            _c("span", { staticClass: "series-PageTitle_Logo" }, [
              _vm._v("SERVICE")
            ]),
            _vm._v(" "),
            _c(
              "span",
              {
                staticClass: "series-PageTitle_Title",
                staticStyle: { color: "#FFF" }
              },
              [_vm._v("サービス案内")]
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "sw-parallax" }, [
            _c("div", { staticClass: "sw-parallax_outer js-parallax_outer" }, [
              _c("div", { staticClass: "sw-parallax_inner" }, [
                _c(
                  "div",
                  { staticClass: "sw-parallax_block js-parallax_block" },
                  [
                    _c("div", {
                      staticClass:
                        "sw-parallax_target promotion-PageTitle-visual",
                      staticStyle: {
                        background:
                          "url(../../../../static/img/service/top.jpg) 50%/cover no-repeat",
                        top: "70px",
                        height: "480px"
                      }
                    })
                  ]
                )
              ])
            ])
          ])
        ]
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row mx-0 mt-6 mt-md-8" }, [
      _c(
        "div",
        {
          staticClass:
            "common-image-appear service-index-appear-3 col-md-6 p-0",
          attrs: { "data-appear": "true" }
        },
        [
          _c("picture", { staticClass: "mb-0" }, [
            _c("img", {
              attrs: {
                src: require("../../../../static/img/service/develop.jpg"),
                alt: ""
              }
            })
          ])
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass:
            "top-card_Row-common service-index-appear-4 pr-0 pl-0 col-md-6 p-0",
          attrs: { "data-appear": "" }
        },
        [
          _c(
            "div",
            {
              staticClass: "top-card_Row-text-common service-index-appear-5",
              attrs: { "data-appear": "" }
            },
            [
              _c("div", { staticClass: "px-5 py-4 text" }, [
                _vm._v(
                  "\n                    弊社は受託開発のサービスをご提供しています。"
                ),
                _c("br"),
                _vm._v(
                  "業務アプリケーション、インフラ構築、組込みソフト、\n                    物流管理システムなど幅広い開発ノウハウを持っており、企画からの受託開発サービスをご提供可能です。\n                    お客様へ付加価値の高いシステムのご提案をお任せて下さい。\n                  "
                )
              ])
            ]
          )
        ]
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row mx-0 mt-6 mt-md-6" }, [
      _c(
        "div",
        {
          staticClass:
            "common-image-appear service-index-appear-8 col-md-12 p-0",
          attrs: { "data-appear": "true" }
        },
        [
          _c("picture", { staticClass: "mb-0" }, [
            _c("img", {
              attrs: {
                src: require("../../../../static/img/service/01.jpg"),
                alt: ""
              }
            })
          ])
        ]
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "li",
      {
        staticClass: "st-BreadcrumbsList_Item",
        attrs: {
          itemprop: "itemListElement",
          itemscope: "itemscope",
          itemtype: ""
        }
      },
      [
        _c(
          "p",
          {
            staticStyle: { "margin-bottom": "0rem" },
            attrs: { itemprop: "item", "aria-current": "page" }
          },
          [
            _c("span", { attrs: { itemprop: "name" } }, [
              _vm._v("サービス案内")
            ])
          ]
        ),
        _vm._v(" "),
        _c("meta", { attrs: { itemprop: "position", content: "3" } })
      ]
    )
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-40cfb094", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-40cfb094","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/service/service.vue
// module id = null
// module chunks = 